import React from 'react'

export default function CancelLink({ linkId }) {
  return (
    <section className="ob-error">
      <h1 className="zb-heading2">Cancel Failed</h1>

      <div className="zb-card">
        <div className="zb-card-body">
          Your attempt to cancel link {linkId} failed.
        </div>
      </div>
    </section>
  )
}
